import store from '../../store';

const initialValues = () => {
  const values = store.getState().consoleBrok1;

  return {
    purpose_of_loan: values.purpose_of_loan,
    property_type: values.property_type,
    no_of_units: values.no_of_units,
    transaction_type: values.transaction_type,
    use_of_funds: values.use_of_funds,
    occupancy: values.occupancy,
    occupancy_at_closing: values.occupancy_at_closing,
    suburban_or_rural: values.suburban_or_rural,
    coe_date: values.coe_date,
    exit_strategy: values.exit_strategy,
    exit_repay_loan: values.exit_repay_loan,
    property_income: values.property_income,
  };
};

export default initialValues;



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/initialValues.js